"use client";

import Download from "@/SvgIcons/Download";
import styles from "./ProgramCurriculumLp.module.scss";
import DownArrow from "@/SvgIcons/DownArrow";
import { useEffect, useState } from "react";
import clsx from "clsx";
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";

const IMG_BASE_URL = process.env.NEXT_PUBLIC_NEW_IMAGE_PATH;

const parseSemesterData = (data) => {
  const result = {};

  data.forEach(({ heading, subtitle }) => {
    result[heading] = subtitle
      .split('\n')
      .map(item => item.replace(/^-/, '').trim())
      .filter(Boolean);
  });

  return result;
}
interface ProgramCurriculumLpProps {
  CourseCurriculum: {
    PerSemCurriculum: {
      heading: string;
      subtitle: string;
    }[];
  };
  associatedPrograms?: any
  Brochure?: {
    data?:{
      attributes:{
        url?:string
      }
    }
  }
  DegreeOfferedByUs?:any
}

const ProgramCurriculumLp = ({ CourseCurriculum, associatedPrograms ,Brochure={},DegreeOfferedByUs}:ProgramCurriculumLpProps) => {
  const [currentSelected, setCurrentSelected] = useState("");
   const modalDispatch = useModalDispatch();
  const couseCurriculum = parseSemesterData(CourseCurriculum.PerSemCurriculum);
  const BrochureLink=Brochure?.data?.attributes?.url

  const isMobile = () => {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
  };

  const toggleCurrentSelected = (item) => {
    if (currentSelected == item) {
      setCurrentSelected("");
    } else {
      setCurrentSelected(item);
    }
  };

  useEffect(()=>{
    if(isMobile()){
       setCurrentSelected(CourseCurriculum?.PerSemCurriculum[0]?.heading|| "");
    }
  },[]);

  const downloadBrochureRFIHandler = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalMba,
        modalData: {
          modalVariant: "downloadBrochure",
          attachmentURL: BrochureLink,
          associatedPrograms,
          rfiCase: "DOWNLOAD_BROCHURE_CASE_THANK_YOU",
          isLambdaAPI: true
        },
      },
    });

    setTimeout(() => {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Download Brochure",
        section_name: "program_curriculum",
        page_type: getGlobalStateValue("pageType"),
        page_url: window.location.href,
      });

      updateStateSession({
        parentSection: "program_curriculum",
        leadStartingCta: "Download Brochure",
      });
    }, 2000);


  };

  return (
    <div className={styles.container} id="curriculum">
      <div className={styles.containerInner}>
        <div className={styles.lhs}>
          <div className={styles.heading}>
            <h2>Program Curriculum</h2>
            <button onClick={downloadBrochureRFIHandler} className={styles.downloadBrochure}>
              Download Brochure <Download />{" "}
            </button>
          </div>

          <div className={styles.semBtnWrapper}>
            <div className={styles.semBtnWrapperInner}>
              {Object.keys(couseCurriculum).map((item, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSelected(item)}
                  className={clsx(styles.perSemBtn, {
                    [styles.perSemBtnSelected]: currentSelected == item,
                  })}
                >
                  {item}
                </button>
              ))}
            </div>

            <div className={styles.sub_list}>
              <ul>
                {couseCurriculum[currentSelected]?.map((item, idx) => (
                  <li key={`${currentSelected}-${idx}`}>
                    <img
                      className={styles.tickIconMweb}
                      src={IMG_BASE_URL + "_s/image_37_Traced_82cbc13164.webp"}
                      alt="Amity Online"
                    />{" "}
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className={styles.semesterWrapper}>
            {Object.keys(couseCurriculum).map((item) => (
              <div key={item} className={styles.perOuterSemester}>
                <div onClick={() => toggleCurrentSelected(item)} className={styles.perSemester}>
                  <p>{item}</p>
                  <div className={item == currentSelected ? styles.rotate180 : styles.rotate0}>
                    <DownArrow />{" "}
                  </div>
                </div>

                <div
                  className={clsx(styles.semesterContent, {
                    [styles.semesterContentOpen]: item === currentSelected,
                  })}
                >
                  <div className={styles.semesterContentInner}>
                    <ul>
                      {couseCurriculum[item]?.map((subItem, idx) => (
                        <li key={`${item}-${idx}`}>
                          <img
                            className={styles.tickIcon}
                            src={IMG_BASE_URL + "_s/image_37_Traced_82cbc13164.webp"}
                            alt="Amity Online"
                          />{" "}
                          {subItem}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.rhs}>
          <img
            className={styles.ugcDegreeBigImg}
            src={DegreeOfferedByUs?.Image.source?.data[0]?.attributes?.url}
            alt="Amity Online Degree"
          />

          <div className={styles.ugcWrapper}>
            <img
              className={styles.ugcDegreeImg}
              src={IMG_BASE_URL + "_s/svg_1_7fdeacbfe6.webp"}
              alt="UGC degree"
            />
            <p className={styles.ugcDegree}>
              {" "}
              UGC-entitled online degree, equivalent to on-campus programs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramCurriculumLp;
